import { NewDate } from '@/Domain/News'
import { Percentage } from '@/Domain/Expediente/Percentage'
import { Currency } from '@/Domain/Batch/Currency'
import { FinalSettlementPositive } from '@/Domain/Expediente'

export class FinalSettlementPositiveDto {
    private _importeLiquidar: Currency | null
    private _iva: Percentage | null
    private _importeLiquidarIva: Currency | null
    private _dataIngresoAdxudicatario: NewDate | null
    private _dataIngresoIvaPropetario: NewDate | null
    private _participacionPropiedad: Percentage | null
    private _importePropiedade: Currency | null
    private _dataPagoPropiedade: NewDate | null
    private _participacionAdministracion: Percentage | null
    private _importeDevolucionAdministracion: Currency | null
    private _dataPagoAdministracion: NewDate | null

    static fromFinal (final: FinalSettlementPositive): FinalSettlementPositiveDto {
      return new FinalSettlementPositiveDto(
        final.importeLiquidar,
        new Percentage(final.iva),
        final.importeLiquidarIva,
        final.dataIngresoAdxudicatario ? new NewDate(final.dataIngresoAdxudicatario) : null,
        final.dataIngresoIvaPropetario ? new NewDate(final.dataIngresoIvaPropetario) : null,
        final.participacionPropiedad ? new Percentage(final.participacionPropiedad) : null,
        final.importePropiedade ? final.importePropiedade : null,
        final.dataPagoPropiedade ? new NewDate(final.dataPagoPropiedade) : null,
        final.participacionAdministracion ? new Percentage(final.participacionAdministracion) : null,
        final.importeDevolucionAdministracion ? final.importeDevolucionAdministracion : null,
        final.dataPagoAdministracion ? new NewDate(final.dataPagoAdministracion) : null
      )
    }

    constructor (
      importeLiquidar: Currency | null,
      iva: Percentage | null,
      importeLiquidarIva: Currency | null,
      dataIngresoAdxudicatario: NewDate | null,
      dataIngresoIvaPropetario: NewDate | null,
      participacionPropiedad: Percentage | null,
      importePropiedade: Currency | null,
      dataPagoPropiedade: NewDate | null,
      participacionAdministracion: Percentage | null,
      importeDevolucionAdministracion: Currency | null,
      dataPagoAdministracion: NewDate | null
    ) {
      this._importeLiquidar = importeLiquidar
      this._iva = iva
      this._importeLiquidarIva = importeLiquidarIva
      this._dataIngresoAdxudicatario = dataIngresoAdxudicatario
      this._dataIngresoIvaPropetario = dataIngresoIvaPropetario
      this._participacionPropiedad = participacionPropiedad
      this._importePropiedade = importePropiedade
      this._dataPagoPropiedade = dataPagoPropiedade
      this._participacionAdministracion = participacionAdministracion
      this._importeDevolucionAdministracion = importeDevolucionAdministracion
      this._dataPagoAdministracion = dataPagoAdministracion
    }

    get importeLiquidar (): Currency {
      if (this._importeLiquidar !== null) {
        return this._importeLiquidar
      } else { return new Currency(0) }
    }

    get iva (): number {
      if (this._iva !== null) {
        return this._iva.percentage()
      } else { return 0 }
    }

    get importeLiquidarIva (): Currency {
      if (this._importeLiquidarIva !== null) {
        return this._importeLiquidarIva
      } else { return new Currency(0) }
    }

    get dataIngresoAdxudicatario (): string {
      if (this._dataIngresoAdxudicatario !== null) {
        return this._dataIngresoAdxudicatario.date()
      } else { return '' }
    }

    get dataIngresoIvaPropetario (): string {
      if (this._dataIngresoIvaPropetario !== null) {
        return this._dataIngresoIvaPropetario.date()
      } else { return '' }
    }

    get participacionPropiedad (): number {
      if (this._participacionPropiedad !== null) {
        return this._participacionPropiedad.percentage()
      } else { return 0 }
    }

    get importePropiedade (): Currency {
      if (this._importePropiedade !== null) {
        return this._importePropiedade
      } else { return new Currency(0) }
    }

    get dataPagoPropiedade (): string {
      if (this._dataPagoPropiedade !== null) {
        return this._dataPagoPropiedade.date()
      } else { return '' }
    }

    get participacionAdministracion (): number {
      if (this._participacionAdministracion !== null) {
        return this._participacionAdministracion.percentage()
      } else { return 0 }
    }

    get importeDevolucionAdministracion (): Currency {
      if (this._importeDevolucionAdministracion !== null) {
        return this._importeDevolucionAdministracion
      } else { return new Currency(0) }
    }

    get dataPagoAdministracion (): string {
      if (this._dataPagoAdministracion !== null) {
        return this._dataPagoAdministracion.date()
      } else { return '' }
    }
}
